import React from 'react';
import { SvgType } from '../svgType';

export default ({ className }: SvgType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32.642"
    height="20.784"
    viewBox="0 0 32.642 20.784"
    className={className}
  >
    <g
      id="Group_19757"
      data-name="Group 19757"
      transform="translate(948 -969.7)"
    >
      <path
        id="Path_9279"
        data-name="Path 9279"
        d="M-947.567,974.2a3.155,3.155,0,0,0-.433,1.566v14.756a2.941,2.941,0,0,0,.433,1.532l8.927-8.927Z"
        transform="translate(0 -3.001)"
        fill="#c1c1c1"
      />
      <path
        id="Path_9280"
        data-name="Path 9280"
        d="M-925.247,1006.9a4.563,4.563,0,0,1-3.231,1.332,4.451,4.451,0,0,1-3.231-1.332l-2.6-2.6-8.893,8.893a2.952,2.952,0,0,0,1.432.366h26.647a3.051,3.051,0,0,0,1.432-.366l-8.893-8.893Z"
        transform="translate(-3.201 -23.075)"
        fill="#c1c1c1"
      />
      <path
        id="Path_9281"
        data-name="Path 9281"
        d="M-869.173,974.2l-8.927,8.927,8.927,8.927a2.941,2.941,0,0,0,.433-1.532V975.766A2.971,2.971,0,0,0-869.173,974.2Z"
        transform="translate(-46.617 -3.001)"
        fill="#c1c1c1"
      />
      <path
        id="Path_9282"
        data-name="Path 9282"
        d="M-930.543,982.69a3.054,3.054,0,0,0,2.132.866,3.114,3.114,0,0,0,2.132-.866l12.624-12.624a2.921,2.921,0,0,0-1.4-.366H-941.7a2.825,2.825,0,0,0-1.4.366Z"
        transform="translate(-3.268 0)"
        fill="#c1c1c1"
      />
    </g>
  </svg>
);
